import Vue from 'vue'
import Cookies from 'js-cookie'
import store from '@/store'

import { getOrigin } from '@/utils/getUserAgent' // 全局注册组件

const MATOMO_HOST = '//matomo.eeeoeee.com/'

const appagentparam = getOrigin() // app进来的数据
console.log('appagentparam?.BasicData', appagentparam?.BasicData)
let SITE_ID = '1'
const basicdataVal = appagentparam && appagentparam.BasicData && appagentparam.BasicData
if (basicdataVal?.includes(',1000,')) {
  SITE_ID = '75'
} else if (basicdataVal?.includes(',701,')) {
  SITE_ID = '72'
} else if (basicdataVal?.includes(',700,')) {
  SITE_ID = '81'
}
console.log('SITE_ID', SITE_ID)
let initialized = false

function bootstrap() {
  if (initialized) return
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  initialized = true

  const _paq = (window._paq = window._paq || [])
  _paq.push(['trackPageView'])
  _paq.push(['enableLinkTracking'])
  _paq.push(['setTrackerUrl', MATOMO_HOST + 'matomo.php'])
  _paq.push(['setSiteId', SITE_ID])

  const akamaitraceid = (store && store.state && store.state.base && store.state.base.akamaitraceid) || Cookies.get('setakamaitraceid')
  if (akamaitraceid) {
    _paq.push(['setCustomDimension', 1, akamaitraceid])
  }

  const d = document
  const g = d.createElement('script')
  const s = d.getElementsByTagName('script')[0]
  g.async = true
  g.src = MATOMO_HOST + 'matomo.js?v=' + new Date().getTime()
  if (s && s.parentNode) {
    s.parentNode.insertBefore(g, s)
  } else {
    d.head.appendChild(g)
  }
}

function readBfp() {
  try {
    return localStorage.getItem('wiki-bfp') || '822ca7b3261a0b2ec10c8cdabfb5a0ea'
  } catch (e) {
    return '822ca7b3261a0b2ec10c8cdabfb5a0ea'
  }
}

function buildBasicData(base, bfp) {
  if (base && base.isWiki == '1') {
    return `999,0,2,999,0,${bfp},0`
  }
  if (base && base.myCountry === 'cn') {
    return `999,0,1,999,1,${bfp},1`
  }
  return `999,0,2,999,0,${bfp},0`
}

export function matomofn(event, obj) {
  if (typeof window === 'undefined') return
  bootstrap()

  const base = (store && store.state && store.state.base) || {}
  const bfp = readBfp()
  const basicData = buildBasicData(base, bfp)
  const akamaitraceid = base.akamaitraceid || Cookies.get('setakamaitraceid') || ''
  const userId = (base.user && base.user.userId) || ''
  const userVip = (base.user && base.user.userVip) || ''
  const languageCode = base.LanguageCode || ''
  const countryCode = base.CountryCode || ''

  let extra = ''
  if (obj && typeof obj === 'object') {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        extra += `&${key}=${obj[key]}`
      }
    }
  }

  const payload = `userid=${userId}&basicdata=${basicData}&Langugecode=${languageCode}&countryCode=${countryCode}&akamai_trace_id=${akamaitraceid}&isVip=${userVip}${extra}`

  if (window._paq && typeof window._paq.push === 'function') {
    window._paq.push(['trackEvent', payload, 'Click', event])
    if (akamaitraceid) {
      window._paq.push(['setCustomDimension', 1, akamaitraceid])
    }
  }
}

// 与 web-wikifxcom 保持一致：通过 Vue.prototype 暴露 this.matomofn
Vue.prototype.matomofn = matomofn

export default matomofn
